<body class="base_color">
  <router-outlet></router-outlet>
  <ebw-loading class="loading"></ebw-loading>
</body>
